import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["actionId", "actionMetadata", "flowObjectTypeId", "getActionOutputsForTargetActionById", "getHeaderTitle"];
import PropTypes from 'prop-types';
// @ts-expect-error untyped module customer-data-objects-ui-components
import ObjectTypeIdType from 'customer-data-objects-ui-components/propTypes/ObjectTypeIdType';
import SetPropertyActionMetadata from 'automation-ui-action-features/actions/set-property/SetPropertyActionMetadata';
import AutomationBuilderCard from 'automation-ui-flow-core/canvas/AutomationBuilderCard';
import SetPropertyActionSummary from 'automation-ui-action-features/actions/set-property/SetPropertyActionSummary';
import { jsx as _jsx } from "react/jsx-runtime";
function SetPropertyActionCard(_ref) {
  let {
      actionId,
      actionMetadata,
      flowObjectTypeId,
      getActionOutputsForTargetActionById,
      getHeaderTitle
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(AutomationBuilderCard, Object.assign({}, rest, {
    headerTitle: getHeaderTitle({
      actionId
    }),
    content: /*#__PURE__*/_jsx(SetPropertyActionSummary, {
      actionId: actionId,
      actionMetadata: actionMetadata,
      getActionOutputsForTargetActionById: getActionOutputsForTargetActionById,
      flowObjectTypeId: flowObjectTypeId,
      getActionLabelById: getHeaderTitle
    })
  }));
}
SetPropertyActionCard.propTypes = {
  actionId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  actionMetadata: PropTypes.instanceOf(SetPropertyActionMetadata).isRequired,
  flowObjectTypeId: ObjectTypeIdType.isRequired,
  getActionOutputsForTargetActionById: PropTypes.func.isRequired,
  getHeaderTitle: PropTypes.func.isRequired
};
export default SetPropertyActionCard;